import { protocolBrandPath } from '@hub/common';
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from 'firebase/storage';
import type { BrandFile } from '@hub/common';

export const uploadBlobToStorage = (
  path: string,
  blob: Blob
): Promise<string> => {
  const storage = getStorage();
  const storageRef = ref(storage, path);

  const metadata = {
    contentType: blob.type,
    cacheControl: 'public,max-age=31536000,immutable',
  };

  const uploadTask = uploadBytesResumable(storageRef, blob, metadata);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      'state_changed',
      snapshot => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress.toFixed(1)} % done`);
      },
      reject,
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        console.log(`${path} uploaded to ${url}`);
        resolve(url);
      }
    );
  });
};

export const uploadFileToStorage = (
  path: string,
  type: 'definition' | 'translation' | 'style',
  content: string
): Promise<string> => {
  console.log('uploadFileToStorage');

  const mimeTypes = {
    translation: 'application/json',
    definition: 'text/plain',
    style: 'text/css',
  };

  return uploadBlobToStorage(
    path,
    new Blob([content], { type: mimeTypes[type] })
  );
};

/** Uploads the protocol's brand copy: its brand file, or JSON `null`. */
export const uploadProtocolBrand = (
  protocolId: string,
  file: BrandFile | null
): Promise<string> =>
  uploadBlobToStorage(
    protocolBrandPath(protocolId),
    new Blob([JSON.stringify(file)], { type: 'application/json' })
  );
